import React, { useState, useEffect } from 'react'
import { Navigate,Link, useParams } from 'react-router-dom';
import FetchFavoriteSections from '../components/FetchFavoriteSections';
import FetchUsertags from '../components/FetchUsertags';
import Fetchbookmarks from '../components/Fetchbookmarks';
import FetchSectionspopupV2 from '../components/FetchSectionspopupV2';
import FetchUserpopupV2 from '../components/FetchUserpopupV2';
import {getFavoriteAuthor,getFavoriteTopics} from '../config/Variables';




function MyFavoriteTags() {
  const users = [];
  const sectionsarray = [];
  const [name, setFirstname] = useState("undefined");
  const [sectionstid, setSectionstid] = useState("undefined");
  const [isLoadingg, setIsLoading] = useState(false);
  const [removedPageSecions, setPageSections] = useState([]);
  const [removedPageUsers, setPageUsers] = useState([]);
  const { section } = useParams();
  const handleChecknow = (evnt) => {
    if (evnt === 'selectauthorpopup') {
      window.location.reload(false);
    }
  }

  const handleCheckedPopup = (tid) => {
    //document.getElementById('custom-section-checkbox-'+tid).defaultChecked=false;
    
     // pageHobbies.splice(tid, 1);
     removedPageSecions.push(tid);
     console.log("this is removed section tid:"+removedPageSecions[0]);
    

  }

  const handleUserCheckedPopup = (tid) => {
    //document.getElementById('custom-section-checkbox-'+tid).defaultChecked=false;
    
     // pageHobbies.splice(tid, 1);
     removedPageUsers.push(tid);
     console.log("this is removed user tid:"+removedPageUsers);
    

  }
//console.log(section);

  var x = "";



  if (localStorage.getItem('user-info')) {
    let user = JSON.parse(localStorage.getItem('user-info'))
  }
  useEffect(() => {
    if (localStorage.getItem('user-info')) {
      const isLoading = true;
      let item = { isLoading };
      let user = JSON.parse(localStorage.getItem('user-info'))
      let datt = fetch(getFavoriteAuthor, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": 'application/json',
          "Authorization": "Bearer " + user.token.access_token,
        },
        body: JSON.stringify(item)
      }).then(response => response.json())
        .then(data => {
          if(data.webmsg.code==401){
            localStorage.clear();
            var domainurl=  window.location.origin;
            window.location.href = domainurl+'/journey';
          }
          data.data.map(({ tid }, index2) => {

            users.push(tid);

          });
         // console.log(users.join('+'));
          //console.log("ttttt");
          setFirstname(users.join('+'));
         
          setIsLoading(true);


        });
    }
    if (localStorage.getItem('user-info')) {
        const isLoading = true;
        let item = { isLoading };
        let user = JSON.parse(localStorage.getItem('user-info'))
        let datt = fetch(getFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        }).then(response => response.json())
          .then(data => {
            data.data.map(({ tid }, index2) => {
  
                sectionsarray.push(tid);
  
            });
           // console.log(users.join('+'));
            //console.log("ttttt");
            setSectionstid(sectionsarray.join('+'));
           
            setIsLoading(true);
  
  
          });
      }

  }, []);
  
  if (!localStorage.getItem('user-info')) {
    return <Navigate to="/" />
} else{
  return (
    <>
      
        
      <main> 
        
                        <div className="grid-container small-grid-collapse fixed-y">
            <ul className="c-tabs c-tabs_js hide-for-large">
                <li><a className="is-active" href="#" data-id="myTags">مواضيعي</a></li>
                <li><a href="#" data-id="myAuthors">كتابي</a></li>
            </ul>
        
            <div className="vertical-separator grid-x grid-margin-x align-center align-justify">   
  
            {sectionstid!="undefined" ?    <FetchFavoriteSections url={`articlebytaxonomy/${sectionstid}`} parameters={sectionstid} />  : ""}
            {name!="undefined" ?    <FetchUsertags url={`opinionapi/${name}`} parameters={name} />  : ""}
         
               
        
               
            </div> 
        </div>
        
        <FetchUserpopupV2 fetchuserpopupcallback={handleUserCheckedPopup} pUsers={removedPageUsers} fetchownusercallback={handleChecknow} />

        <FetchSectionspopupV2 fetchpopupcallback={handleCheckedPopup} pSections={removedPageSecions} fetchownusercallback={handleChecknow} />
                  
    </main>
                    





   
    </>
  );


}
}
export default MyFavoriteTags;
